// Singleton SignClient für WalletConnect v2
import { SignClient } from "@walletconnect/sign-client";
import QRCode from 'qrcode';
import {
  getV3TaxAbsoluteIconUrl,
  getV3TaxAppOrigin,
} from "../constants/v3taxBranding.js";

let clientPromise = null;

// 🚀 WICHTIG: Funktion zum Reset des Clients (wenn Metadata-URL geändert wurde)
export function resetSignClient() {
    clientPromise = null;
  
  // Lösche auch localStorage WalletConnect-Daten
  if (typeof window !== 'undefined' && window.localStorage) {
    const keysToRemove = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key && (key.startsWith('wc@') || key.includes('walletconnect') || key.startsWith('wc_'))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => {
            window.localStorage.removeItem(key);
    });
      }
}

// STABILES Metadata-Objekt (GPT 5 Ratschlag - Byte-stabil einfrieren!)
// WICHTIG: Dynamische URL basierend auf Umgebung für Production-Kompatibilität!
const getAppUrl = () => {
  // 🚀 WICHTIG: IMMER die echte Origin verwenden (inkl. www)!
  // WalletConnect Verify vergleicht Origin mit metadata.url - bei Mismatch kommt "Failed to publish custom payload"
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
        return origin;
  }
  
  // Fallback nur wenn window nicht verfügbar (SSR)
  const envUrl = import.meta.env?.VITE_APP_URL;
  if (envUrl) {
        return envUrl;
  }
  
  // Letzter Fallback
  return import.meta.env?.PROD ? 'https://v3tax.app' : 'http://localhost:5173';
};

const WALLETCONNECT_APP_NAME = 'V3Tax';
const WALLETCONNECT_APP_DESCRIPTION =
  'VeChain tax analysis and Smart Scan for wallets.';

// WICHTIG: Metadata wird NICHT mehr hier erstellt, sondern dynamisch in getSignClient()
// Das stellt sicher, dass window.location verfügbar ist

const WALLETCONNECT_CONFIG = {
  projectId: import.meta.env?.VITE_WC_PROJECT_ID || '60635421b58cacf2ec5083593e40ffcf',
  relayUrl: 'wss://relay.walletconnect.com',
  maxLoggingLevel: 2
  // metadata wird dynamisch in getSignClient() erstellt
};

// Pairing-Topic persistent speichern
const PAIRING_KEY = "wc_v3tax_pairing_topic";

export function savePairing(topic) {
  localStorage.setItem(PAIRING_KEY, topic);
  }

export function loadPairing() {
      
  const allKeys = Object.keys(localStorage);
  const pairingKeys = allKeys.filter(key => key.includes('pairing') || key.includes('wc_'));
      
  const topic = localStorage.getItem(PAIRING_KEY);
            
  if (topic) {
      } else {
      }
  
  return topic;
}

export async function clearPairing() {
  try {
    // 1) Pairing aus localStorage entfernen
    const storedPairing = localStorage.getItem(PAIRING_KEY);
    localStorage.removeItem(PAIRING_KEY);
        
    // 2) Pairing auch im WalletConnect Client trennen
    if (storedPairing) {
      try {
        const client = await getSignClient();
        const activePairings = client.core.pairing.getPairings().filter(p => p.active);
        
        // Alle aktiven Pairings trennen, die dem gespeicherten entsprechen
        for (const pairing of activePairings) {
          if (pairing.topic === storedPairing) {
                        await client.core.pairing.disconnect({ topic: pairing.topic });
                      }
        }
      } catch (disconnectError) {
              }
    }
    
      } catch (error) {
      }
}

// SignClient als echtes Singleton
export function getSignClient() {
  if (!clientPromise) {
        
    // Metadata dynamisch beim Init erstellen (damit window.location verfügbar ist)
    const origin = getAppUrl();
    const metadataUrl = getV3TaxAppOrigin(origin);

    const dynamicMetadata = {
      name: WALLETCONNECT_APP_NAME,
      description: WALLETCONNECT_APP_DESCRIPTION,
      url: metadataUrl,
      icons: [getV3TaxAbsoluteIconUrl(metadataUrl)],
      verifyUrl: 'https://verify.walletconnect.com'
    };

    if (typeof window !== "undefined") {
      window.__V3TAX_WALLETCONNECT_METADATA__ = dynamicMetadata;
    }
    
    // 🚀 WICHTIG: Debug-Logging für Production-Debugging
                                
    const config = {
      projectId: WALLETCONNECT_CONFIG.projectId,
      metadata: dynamicMetadata, // Dynamisches Metadata mit korrekter URL
      relayUrl: WALLETCONNECT_CONFIG.relayUrl,
      maxLoggingLevel: WALLETCONNECT_CONFIG.maxLoggingLevel
    };
    
        
    clientPromise = SignClient.init(config).catch(error => {
            // Client-Reset bei Init-Fehler
      clientPromise = null;
      throw error;
    });
    
    // Event-Listener für Pairing-Erstellung (GPT 5 Ratschlag)
    clientPromise.then(client => {
            
      // Pairing-Events überwachen
      client.core.pairing.events.on('pairing_create', (e) => {
              });
      client.core.pairing.events.on('pairing_update', (e) => {
              });
      
      // Session-Events überwachen - GPT 5: Logge explizit die Metadaten, die VeWorld sieht!
      client.events.on('session_proposal', (e) => {
                                      });
      client.events.on('session_delete', (e) => {
              });
      
      // GPT 5: Event-Listener für Account-Wechsel und Session-Updates
      client.events.on('session_update', (e) => {
                        
        // Hier könnte die dApp ihren State aktualisieren
        // z.B. neue Accounts anzeigen, UI aktualisieren
        if (window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('walletconnect:accountsChanged', {
            detail: { accounts: e.params.namespaces }
          }));
        }
      });
      
      // GPT 5: Event-Listener für Session-Events (Account-Wechsel)
      client.events.on('session_event', (e) => {
                if (e.params.event.name === 'accountsChanged') {
                    
          // Benachrichtige die dApp über Account-Wechsel
          if (window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent('walletconnect:accountsChanged', {
              detail: { accounts: e.params.event.data }
            }));
          }
        }
      });
      
      // GPT 5: Logge alle aktiven Pairings mit ihren Peer-Metadaten
          });
  }
  return clientPromise;
}

// GPT 5: Prüfe nach IRGENDEINER gültigen Session - das ist der Schlüssel!
export async function findExistingSession() {
  try {
    const client = await getSignClient();
    
    // Alle aktiven Sessions durchsuchen
    const allSessions = client.session.getAll();
        
    // GPT 5: Debug-Info für alle Sessions
    const sessionInfo = allSessions.map(s => ({ 
      topic: s.topic, 
      expiry: s.expiry, 
      peer: s.peer?.metadata?.name,
      active: s.active,
      pairingTopic: s.pairingTopic
    }));
        
    // GPT 5: Korrigierter Zeitvergleich - expiry ist in Sekunden, Date.now() in Millisekunden!
    const now = Date.now();
        
    // GPT 5: NUR auf Ablauf prüfen – keine weiteren harten Filter!
    // active=undefined ist normal für WalletConnect Sessions!
    const existingSession = allSessions.find(s => 
      (s.expiry * 1000) > now // WICHTIG: expiry * 1000 für Millisekunden-Vergleich!
    );
    
    if (existingSession) {
                              return { success: true, session: existingSession, isNewPairing: false };
    } else {
            if (allSessions.length > 0) {
                allSessions.forEach(s => {
          const expiryMs = s.expiry * 1000;
          const isValid = expiryMs > now;
                  });
      } else {
              }
      return { success: false, error: 'Keine gültige Session' };
    }
    
  } catch (error) {
        return { success: false, error: error.message };
  }
}

// GPT 5: NEUE LOGIK - Session-Reuse statt immer connect()!
// options.forceFresh: kein Session-Reuse (z. B. Mobile „Account wechseln“ → neuer Deep-Link/Approval)
export async function connectVeWorld(requiredNamespaces, options = {}) {
  const { forceFresh = false } = options;
  try {
        
    const client = await getSignClient();
    
    // GPT 5: KEINE eigenen localStorage-Pairing-Keys mehr verwenden!
    // Nutze ausschließlich signClient.core.pairing.pairings (der SDK-Store ist die Quelle der Wahrheit)
    const activePairings = client.core.pairing.getPairings().filter(p => p.active);
        
    if (!forceFresh) {
      // 1) GPT 5: BESTEHENDE SESSION WIEDERVERWENDEN - KEIN connect()!
      // WICHTIG: Suche nach IRGENDEINER gültigen Session (ohne Pairing-Filter!)
      const sessionResult = await findExistingSession();
      
      if (sessionResult.success) {
                        return { 
          session: sessionResult.session, 
          isNewPairing: false,
          reusedExistingSession: true
        };
      } else {
                
        // 🚀 WICHTIG: Direkt QR-Code generieren - keine Session über bestehendes Pairing versuchen!
        // Das verhindert die unerwünschte Verbindungsanfrage in VeWorld
              }
    } else {
          }
    
    // QR-Flow für neues Pairing (keine Session über bestehendes Pairing!)
        
    // GPT 5: Korrektes Namespace-Schema ohne Deprecation-Warnung
    try {
      const { uri, approval } = await client.connect({ 
        requiredNamespaces: requiredNamespaces // Korrektes v2 Schema
      });
      
      if (uri) {
                
        // WICHTIG: URI und Approval-Promise sofort zurückgeben
        // Die aufrufende Komponente (WalletConnectModal) ist dafür verantwortlich,
        // den QR-Code anzuzeigen und DANN auf die approval-Promise zu warten.
                return { approval, isNewPairing: true, uri };
      }
      
      throw new Error('Kein URI generiert');
    } catch (connectError) {
            
      // Wenn "Failed to publish custom payload" - Client zurücksetzen und neu versuchen
      if (connectError.message && connectError.message.includes('Failed to publish custom payload')) {
                resetSignClient();
        
        // Neu initialisieren
        const newClient = await getSignClient();
        
        // Erneut versuchen
                const { uri, approval } = await newClient.connect({ 
          requiredNamespaces: requiredNamespaces
        });
        
        if (uri) {
                    return { approval, isNewPairing: true, uri };
        }
      }
      
      throw connectError;
    }
    
  } catch (error) {
        throw error;
  }
}

// GPT 5: App-Logout = nur App-Auth löschen, KEINE WC-Session löschen!
export async function logoutVeWorld() {
  try {
        
    // Debug: Zeige localStorage vor dem Logout
        const allKeysBefore = Object.keys(localStorage);
    const pairingKeysBefore = allKeysBefore.filter(key => key.includes('pairing') || key.includes('wc_'));
                
    const client = await getSignClient();
    
    // WICHTIG: KEINE Sessions beenden - das würde neue VeWorld-Einträge verursachen!
    const sessions = client.session.getAll();
            
    // GPT 5: Nur App-seitige Auth löschen, WalletConnect-Session leben lassen!
            
    // Debug: Zeige localStorage nach dem Logout
        const allKeysAfter = Object.keys(localStorage);
    const pairingKeysAfter = allKeysAfter.filter(key => key.includes('pairing') || key.includes('wc_'));
                
    return { success: true };
    
  } catch (error) {
        throw error;
  }
}

// GPT 5: Account-Wechsel innerhalb derselben Session (ohne neue VeWorld-Einträge!)
export async function switchAccount() {
  try {
        const client = await getSignClient();
    
    // 1) Aktuelle Session finden
    const sessionResult = await findExistingSession();
    if (!sessionResult.success) {
      throw new Error('Keine aktive Session für Account-Wechsel gefunden');
    }
    
    const session = sessionResult.session;
        
    // 2) Versuche eth_requestAccounts (EVM-Standard für Account-Wechsel)
    try {
            await client.request({
        topic: session.topic,
        chainId: 'vechain:b1ac3413d346d43539627e6be7ec1b4a', // Mainnet
        request: { 
          method: 'eth_requestAccounts', 
          params: [] 
        }
      });
      
            return { success: true, method: 'eth_requestAccounts' };
      
    } catch (requestError) {
                  
      // 3) Fallback: Nur Session beenden, keine neue Verbindung
      await client.disconnect({
        topic: session.topic,
        reason: { code: 6000, message: "Account switch requested" }
      });
      
            
      return { 
        success: true, 
        method: 'disconnect_only',
        message: 'Session beendet, neue Verbindung über Login-Modal möglich'
      };
    }
    
  } catch (error) {
        throw error;
  }
}

// GPT 5: Session-Verlängerung vor Ablauf (verhindert Session-Ablauf)
export async function extendSession() {
  try {
        const client = await getSignClient();
    
    const sessionResult = await findExistingSession();
    if (!sessionResult.success) {
            return { success: false, error: 'Keine aktive Session' };
    }
    
    const session = sessionResult.session;
    const now = Date.now();
    const expiryMs = session.expiry * 1000;
    const remainingHours = Math.floor((expiryMs - now) / 1000 / 60 / 60);
    
        
    // Verlängere Session wenn weniger als 24 Stunden übrig
    if (remainingHours < 24) {
      try {
                await client.extend({
          topic: session.topic
        });
        
                return { success: true, extended: true };
        
      } catch (extendError) {
                return { success: false, error: extendError.message };
      }
    } else {
            return { success: true, extended: false };
    }
    
  } catch (error) {
        throw error;
  }
}

// GPT 5: Aufräumen alter/abgelaufener Sessions und verwaister Pairings
export async function cleanupStale() {
  try {
        const client = await getSignClient();
    
    const now = Date.now();
    let cleanedSessions = 0;
    let cleanedPairings = 0;
    
    // 1) Abgelaufene Sessions aufräumen
    const allSessions = client.session.getAll();
        
    for (const session of allSessions) {
      const expiryMs = session.expiry * 1000;
      if (expiryMs <= now) {
        try {
                    await client.disconnect({
            topic: session.topic,
            reason: { code: 6001, message: "Session expired" }
          });
          cleanedSessions++;
        } catch (disconnectError) {
                  }
      }
    }
    
    // 2) Verwaiste Pairings aufräumen (keine aktiven Sessions mehr)
    const allPairings = client.core.pairing.getPairings();
        
    for (const pairing of allPairings) {
      // Prüfe ob dieses Pairing noch aktive Sessions hat
      const hasActiveSessions = allSessions.some(s => 
        s.pairingTopic === pairing.topic && (s.expiry * 1000) > now
      );
      
      if (!hasActiveSessions) {
        try {
                    await client.core.pairing.disconnect({
            topic: pairing.topic,
            reason: { code: 6002, message: "Orphaned pairing" }
          });
          cleanedPairings++;
        } catch (disconnectError) {
                  }
      }
    }
    
        return { 
      success: true, 
      cleanedSessions, 
      cleanedPairings 
    };
    
  } catch (error) {
        throw error;
  }
}

// WICHTIG: Nur wenn User explizit "App trennen" wählt
export async function disconnectEverywhere() {
  try {
    
    const client = await getSignClient();
    const now = Date.now();

    let disconnectedSessions = 0;
    let disconnectedPairings = 0;

    // 1) Alle noch gültigen Sessions trennen (nicht auf session.active verlassen — oft undefined)
    const sessions = client.session.getAll();
    for (const session of sessions) {
      const isValid = session?.expiry ? session.expiry * 1000 > now : true;
      if (!session?.topic || !isValid) continue;

      try {
        await client.disconnect({
          topic: session.topic,
          reason: { code: 6000, message: "User logout" },
        });
        disconnectedSessions++;
              } catch (err) {
              }
    }

    // 2) Danach Pairings trennen (active kann undefined sein — nur explizit false überspringen)
    const pairings = client.core.pairing.getPairings();
    for (const pairing of pairings) {
      if (!pairing?.topic || pairing.active === false) continue;

      try {
        await client.core.pairing.disconnect({
          topic: pairing.topic,
          reason: { code: 6001, message: "User unlinked app" },
        });
        disconnectedPairings++;
              } catch (err) {
              }
    }

    // 3) Gespeichertes Pairing sauber awaiten
    await clearPairing();

    
    // 4) Prüfen, ob wirklich nichts Gültiges mehr übrig ist (gleiche Gültigkeit wie oben)
    const nowAfter = Date.now();
    const remainingSessions = client.session.getAll().filter((s) => {
      if (!s?.topic) return false;
      const stillValid = s?.expiry ? s.expiry * 1000 > nowAfter : true;
      return stillValid;
    });
    const remainingPairings = client.core.pairing.getPairings().filter(
      (p) => p?.topic && p?.active !== false
    );

    if (remainingSessions.length > 0 || remainingPairings.length > 0) {
            return {
        success: false,
        error: 'WalletConnect session/pairing still present after disconnect',
      };
    }

    return { success: true };
  } catch (error) {
        return { success: false, error: error?.message || String(error) };
  }
}

if (typeof window !== "undefined") {
  window.__V3TAX_DEBUG_WC__ = async () => {
    const client = await getSignClient();

    return {
      configuredMetadata: window.__V3TAX_WALLETCONNECT_METADATA__,
      sessions: client.session.getAll().map((s) => ({
        topic: s.topic,
        expiry: s.expiry,
        self: s.self?.metadata || null,
        peer: s.peer?.metadata || null,
        namespaces: s.namespaces || null
      })),
      pairings: client.core.pairing.getPairings().map((p) => ({
        topic: p.topic,
        active: p.active,
        peerMetadata: p.peerMetadata || null
      }))
    };
  };
}
